<template>
  <section>
    <div class="agendas-manager">
      <div class="agendas-header">
        <button class="add-button" @click="createAgenda">Nova agenda</button>
        <button class="close-button" @click="$emit('close')">
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="agendas-list">
        <div v-for="(agenda, index) in localAgendas" :key="agenda.agenda_id || index" class="agenda-item">
          <h3>{{ agenda.agenda }}</h3>
          <p>{{ formatDate(agenda.date_start) }}</p>
          <img v-if="agenda.image" :src="agenda.image" alt="Agenda Image" />
          <div class="agenda-actions">
            <button class="edit-btn" @click="editAgenda(index)">Editar</button>
            <button class="delete-btn" @click="$emit('delete-agenda', agenda.agenda_id)">
              <i class="far fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="agenda-editor" v-if="isEditing">
      <div class="agenda-editor-backdrop" @click="closeOnOutsideClick"></div>
      <div class="agenda-editor-modal">
        <img v-if="pickedAgenda.image" :src="pickedAgenda.image" alt="Agenda Image" @click="showMaterialPicker = true" />
        <label>URL da imagem:</label>
        <input v-model="pickedAgenda.image" @click="showMaterialPicker = !showMaterialPicker" />
        <label>Título:</label>
        <input v-model="pickedAgenda.agenda" />
        <label>Data início:</label>
        <input v-model="pickedAgenda.date_start" type="datetime-local" />
        <div class="agenda-editor-modal-actions">
          <button class="cancel-button" @click="cancelEdit">Cancelar</button>
          <button class="save-button" @click="saveAgenda(pickedAgenda)">Salvar</button>
        </div>
      </div>
      <MaterialPicker class="agenda-materialPicker" :currentDataImages="[pickedAgenda?.image]" @onSelectImage="pickedAgenda.image = $event.src" @close="showMaterialPicker = false" v-if="showMaterialPicker" />
    </div>
  </section>
</template>

<script>
import MaterialPicker from '../../components/general/MaterialPicker.vue';

export default {
  name: 'ScheduleManager',
  components: { MaterialPicker },
  props: {
    agendas: { type: Array, required: true },
  },
  data() {
    return {
      localAgendas: [],
      pickedAgenda: null,
      isEditing: false,
      showMaterialPicker: false,
    };
  },
  watch: {
    agendas: {
      immediate: true,
      handler(newVal) {
        this.localAgendas = [...newVal];
      },
    },
  },
  methods: {
    editAgenda(index) {
      console.log('editAgenda called', index, this.localAgendas[index]);
      // Always create a new object to ensure reactivity
      this.pickedAgenda = Object.assign({}, this.localAgendas[index]);
      if (this.pickedAgenda.date_start) {
        this.pickedAgenda.date_start = this.formatDate(this.pickedAgenda.date_start, true);
      }
      this.isEditing = true;
    },
    saveAgenda(editedAgenda) {
      this.$emit('save', editedAgenda);
      this.isEditing = false;
      this.pickedAgenda = null;
      this.showMaterialPicker = false;
    },
    cancelEdit() {
      this.isEditing = false;
      this.pickedAgenda = null;
      this.showMaterialPicker = false;
      this.$emit('cancel');
    },
    createAgenda() {
      console.log('createAgenda called');
      this.pickedAgenda = {
        agenda: '',
        date_start: '',
        image: '',
      };
      this.isEditing = true;
    },
    formatDate(dateString, forInput = false) {
      const date = new Date(dateString);
      return forInput ? date.toISOString().slice(0, 16) : date.toLocaleString();
    },
    closeOnOutsideClick() {
      this.cancelEdit();
    },
  },
};
</script>

<style scoped lang="scss">
.agendas-manager {
  position: fixed;
  inset: 0;
  width: 100%;
  z-index: 1000;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: 1rem;
  padding: 1rem;
  background: #cccccc;

  &.hidden {
    display: none;
  }
}
.agendas-header {
  position: relative;
  width: 100%;
  padding: 1rem;
  border-radius: 8px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #fff;
  }

  @include media('<=phone') {
    padding: 0;
  }
}
.add-button {
  margin: 0 20px 0 auto;
  padding: 0.5rem 1rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.close-button {
  padding: 0.5rem 1rem;
  background: #494949;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.agendas-list {
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: stretch;
  align-items: stretch;
  gap: 1rem;

  color: #000;
  h3 {
    margin: 0;
    font-size: 1.5rem;
  }
}
.agenda-item {
  position: relative;
  min-height: 300px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #333333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;

  img {
    width: 280px;
    border-radius: 8px;
    object-fit: contain;
  }

  h3 {
    color: #000;
  }

  p {
    color: #000;
  }
}
.agenda-actions {
  margin-top: auto;
  margin-left: auto;
  display: flex;
  gap: 0.5rem;
}

.edit-btn,
.delete-btn {
  padding: 4px 8px;
  background: #585858;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.875rem;
  cursor: pointer;

  &:hover {
    background: #747474;
  }
}

.edit-btn {
  background: transparent;
  border: 1px solid #000;
  color: #000;

  &:hover {
    background: #0069d9;
    border-color: #0062cc;
    color: white;
  }
}

.delete-btn {
  background: transparent;
  border: 1px solid #000;
  color: #000;

  i {
    font-size: 1rem;
    color: #000;

    &:hover {
      color: #fff;
    }
  }

  &:hover {
    background: #c82333;
    border-color: #c82333;
    color: white;
  }
}

.agenda-editor {
  position: fixed;
  inset: 0;
  z-index: 1001;
  padding: 0 4px;
  overflow-y: auto;

  display: flex;
  justify-content: center;
  align-items: center;
}
.agenda-editor-backdrop {
  position: absolute;
  inset: 0;
  background: #cccccc;
}
.agenda-editor-modal {
  background: #dbdbdb;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  position: relative;
  z-index: 1;
}
.agenda-editor-modal label {
  display: block;
  margin-bottom: 6px;
  color: #000000;
}
.agenda-editor-modal img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  margin-bottom: 10px;
  cursor: pointer;
}
.agenda-editor-modal input,
.agenda-editor-modal textarea {
  width: 100%;
  padding: 10px;
  background-color: transparent;
  border: 1px solid #444;
  border-radius: 4px;
  color: #000000;
  font-size: 14px;
  margin-bottom: 16px;

  display: flex;
  justify-content: space-between;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
}

.agenda-editor-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
  }

  .cancel-button {
    background-color: transparent;
    color: #202020;
    border: 1px solid #555;

    &:hover {
      background-color: #666;
      color: white;
    }
  }

  .save-button {
    background-color: #007bff;
    color: white;

    &:hover {
      background-color: #0069d9;
    }
  }
}

.agenda-materialPicker {
  z-index: 1002;
}
</style>
